export const LIKE_ICON = 'LIKE_ICON';
export const SEARCH_GRAY = 'SEARCH_GRAY';
export const ADD_POST = 'ADD_POST';
export const ADD_POST_ACTIVE = 'ADD_POST_ACTIVE';
export const MY_PAGE = 'MY_PAGE';
export const MY_PAGE_ACTIVE = 'MY_PAGE_ACTIVE';
export const SEARCH = 'SEARCH';
export const SEARCH_ACTIVE = 'SEARCH_ACTIVE';
export const HOME = 'HOME';
export const HOME_ACTIVE = 'HOME_ACTIVE';
export const NOTIFICATION = 'NOTIFICATION';
export const ARROW_LEFT = 'ARROW_LEFT';
export const MY_INFO = 'MY_INFO';
export const TAG_DELETE = 'TAG_DELETE';
export const COMMENT = 'COMMENT';
export const EDIT = 'EDIT';
export const LOGOUT = 'LOGOUT';
export const KEY = 'KEY';
export const GRID = 'GRID';
export const GRID_ACTIVE = 'GRID_ACTIVE';
export const GRID_INACTIVE = 'GRID_INACTIVE';
export const HEART = 'HEART';
export const HEART_RED = 'HEART_RED';
export const HEART_ACTIVE = 'HEART_ACTIVE';
export const HEART_INACTIVE = 'HEART_INACTIVE';
export const MORE = 'MORE';
